export default {
    classFix:'ark-bcl-', //class前缀
    componentsFix:'ak-', //components前缀
    prefixCls:'ak-' //前缀
};
